// Spanish translations
const es = {
  // General
  appName: 'LUCIEN14',
  loading: 'Cargando...',
  error: 'Se produjo un error',

  // Navigation
  nav: {
    home: 'Inicio',
    collections: 'Colecciones',
    culinary: 'Culinario',
    menu: 'Menú',
    events: 'Eventos',
    admin: 'Admin'
  },

  // Menu
  menu: {
    title: 'El Menú',
    subtitle: 'Selección de CANS NUIT',
    date: 'NOV 2025',
    footer: 'El menú cambia según la temporada, la inspiración y los ingredientes disponibles (MERSIN NO TIENE TODO — LO INTENTAMOS.) Opciones vegetarianas NO disponibles bajo petición.',

    // Loading stages
    loading: {
      connecting: 'Conectando al servidor...',
      fetching: 'Obteniendo datos del menú...',
      processing: 'Procesando elementos del menú...',
      finalizing: 'Preparando tu experiencia...',
      ready: 'Casi listo...',
      error: 'Error de conexión',
      notFound: 'Menú no encontrado',
      alternative: 'Probando fuente alternativa de menú...',
      hint: 'Nuestro menú vale la pena esperar. Preparando un viaje culinario solo para ti...'
    },

    // Loading phrases
    loadingPhrases: [
      'Buscando el mejor aluminio...',
      'Consultando al sommelier...',
      'Emplatando los conservantes...',
      'Abriendo las latas...',
      'Curando el ambiente...'
    ],

    // Section titles
    sections: {
      entrees: 'Entrantes',
      plats: 'Platos Principales',
      cocktails: 'Cócteles',
      whiskies: 'Whiskies',
      gins: 'Ginebras',
      vins: 'Vinos',
      champagnes: 'Champagnes',
      desserts: 'Postres',
      boissons: 'Bebidas'
    },

    // Error states
    errors: {
      unavailable: 'Menú No Disponible',
      subtitle: 'El chef ha abandonado el edificio',
      footer: 'Por favor, pide una pizza.',
      title: '¡Oh No!'
    }
  },

  // Footer
  footer: {
    designed: 'Diseñado en el LUCIEN14',
    rights: 'Todos los derechos reservados.'
  },

  // Language selector
  language: {
    select: 'Seleccionar idioma',
    en: 'Inglés',
    fr: 'Francés',
    es: 'Español',
    tr: 'Turco'
  }
};

export default es;
